// extracted by mini-css-extract-plugin
module.exports = {"row":"ProblemsTable_row__AMKmd","header":"ProblemsTable_header__2ky1C"};